module.exports = __webpack_public_path__ + "agendor-icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/agendor-icons.ttf?-da6lhh
// module id = 612
// module chunks = 0